<template>
  <v-list-item
    :disabled="featureOption.disabled"
    link
    :data-testid="`option-${featureKey}`"
    @click="!featureOption.options && handleItemClick(featureKey, featureOption)"
  >
    <v-list-item-title>{{ featureOption.dropdownLabel }}</v-list-item-title>
    <template
      v-if="featureOption?.addFeatureIcon?.raw || featureOption?.icon?.raw"
      #prepend
    >
      <component
        :is="featureOption?.addFeatureIcon?.raw ?? featureOption.icon.raw"
        height="24px"
        style="max-width: 24px;"
        class="mr-2"
      />
    </template>
    <template
      v-if="featureOption.options"
      #append
    >
      <v-icon
        icon="mdi-menu-right"
        size="small"
      />
    </template>
    <v-menu
      v-if="featureOption.options"
      :open-on-focus="false"
      activator="parent"
      open-on-hover
      submenu
      :close-on-content-click="false"
    >
      <v-list>
        <AddFeatureItem
          v-for="[optionKey, option] in featureOption.options.entries()"
          :key="optionKey"
          :feature-key="optionKey"
          :feature-option="option"
          @handle-click="handleItemClick"
        />
      </v-list>
    </v-menu>
  </v-list-item>
</template>

<script>
export default {
  props: {
    featureOption: {
      type: Object,
      required: true,
    },
    featureKey: {
      type: String,
      required: true,
    },
  },
  emits: ['handle-click'],
  methods: {
    handleItemClick(featureKey, featureOption) {
      this.$emit('handle-click', featureKey, featureOption);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
